"use client";
/**
 * Tiny client leaves that let the hook-free primitives in ./index.tsx render translated text
 * (they work under both server and client parents; the locale comes from I18nProvider).
 */
import type { ComponentProps } from "react";
import { useT } from "@/i18n/client";
import type { MessageKey } from "@/i18n/messages";
import type { TVars } from "@/i18n/translate";
import { humanize } from "./index";

export function UiText({ k, vars }: { k: MessageKey; vars?: TVars }) {
  const t = useT();
  return <>{t(k, vars)}</>;
}

/** Translated status label ("ui.status_<status>"), falling back to a humanized code for unknown statuses. */
export function StatusText({ status }: { status: string }) {
  const t = useT();
  const key = `ui.status_${status}` as MessageKey;
  const msg = t(key);
  return <>{msg === key ? humanize(status) : msg}</>;
}

/** <nav> whose accessible name is a translation key. */
export function UiNav({ labelKey, ...p }: Omit<ComponentProps<"nav">, "aria-label"> & { labelKey: MessageKey }) {
  const t = useT();
  return <nav {...p} aria-label={t(labelKey)} />;
}
